import { HttpClient, HttpHandler } from "@angular/common/http";
import { RequestOptions, Http } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { HttpModule, XHRBackend } from "@angular/http";
import { routing } from "./app-routing.module";
import { TextMaskModule } from "angular2-text-mask";
import { SelectModule } from "ng2-select";
import { InputMaskModule } from "ng2-inputmask";
import {
  PathLocationStrategy,
  LocationStrategy,
  DatePipe,
} from "@angular/common";
import { SlimLoadingBarModule } from "ng2-slim-loading-bar";
import { ProgressHttpModule } from "angular-progress-http";
import { Angulartics2Module, Angulartics2GoogleAnalytics } from "angulartics2";

import { AppComponent } from "./app.component";
import { CabecalhoComponent } from "./cabecalho/cabecalho.component";
import { RodapeComponent } from "./rodape/rodape.component";
import { InicioComponent } from "./inicio/inicio.component";
import { LoginComponent } from "./login/login.component";
import { CursoComponent } from "./curso/curso.component";
import { DadosPessoaisComponent } from "./dados-pessoais/dados-pessoais.component";
import { EnderecoComponent } from "./endereco/endereco.component";
import { EnsinoMedioComponent } from "./ensino-medio/ensino-medio.component";
import { DocumentoComponent } from "./documento/documento.component";
import { DocumentosComponent } from "./documentos/documentos.component";
import { DocumentosComplementaresComponent } from "./documentos-complementares/documentos-complementares.component";
import { MensagemFinalComponent } from "./mensagem-final/mensagem-final.component";
import { MensagemFinalMatriculaOnlineComponent } from "./mensagem-final-matricula-online/mensagem-final-matricula-online.component";
import { BarraProgressoComponent } from "./_shared/barra-progresso/barra-progresso.component";
import { StepGuard } from "./_guards/step.guard";
import { AuthGuard } from "./_guards/auth.guard";
import { BarraProgressoService } from "./_shared/barra-progresso/barra-progresso.service";
import { AppUploadComponent } from "./_shared/app-upload/app-upload.component";
import { EnderecoService } from "./_shared/endereco/endereco.service";
import { CursosService } from "./_shared/curso/cursos.service";
import { PessoaService } from "./_shared/pessoa/pessoa.service";
import { HistoricoEscolarComponent } from "./historico-escolar/historico-escolar.component";
import { DiplomaComponent } from "./diploma/diploma.component";
import { SessionService } from "./_shared/session/session.service";
import { ValidadoresService } from "./_shared/validadores/validadores.service";
import { ProcessoService } from "./_shared/processo/processo.service";
import { AppAutoFocusDirective } from "./_shared/focus/autofocus.directive";
import { CandidatoService } from "./_shared/candidato/candidato.service";
import { LoaderService } from "./_shared/loader/loader.service";
// import { HttpService } from './_shared/http/http.service';
import { httpServiceFactory } from "./_shared/http/http-service.factory";
import { LoaderComponent } from "./_shared/loader/loader.component";
import { HeaderService } from "./_shared/http/header.service";
import { DocumentoService } from "./_shared/documento/documento.service";
import { GlobalErrorHandler } from "./_shared/error-handler/error-handler";
import { AlertsComponent } from "./_shared/alerts/alerts.component";
import { AlertsService } from "./_shared/alerts/alerts.service";
import { PerguntaDocumentosComponent } from "./pergunta-documentos/pergunta-documentos.component";
import { ProcessoForaPrazoComponent } from "./processo-fora-prazo/processo-fora-prazo.component";
import { DocumentoGlobal } from "./_shared/documento/documento-global";
import { AppDocumentoComponent } from "./_shared/app-documento/app-documento.component";
import { PreCadastroComponent } from "./pre-cadastro/pre-cadastro.component";
import { SafeHtmlPipe } from "./_pipes/safe-html.pipe";
import { RedirecionamentoMatriculaService } from "./_shared/redirecionamento-matricula/redirecionamento-matricula.service";
import { ParametrosGeraisService } from "./_shared/parametros-gerais/parametros-gerais.service";
import { AceiteTermoPrivacidadeService } from "./_shared/aceite-termo-privacidade/aceite-termo-privacidade.service";
import { SweetAlert2Module } from "@toverux/ngx-sweetalert2";
import { ContatoService } from "./_shared/contato/contato.service";
import { MatriculaService } from "./_shared/matricula/matricula.service";

@NgModule({
  declarations: [
    AppComponent,
    CabecalhoComponent,
    RodapeComponent,
    InicioComponent,
    LoginComponent,
    CursoComponent,
    DadosPessoaisComponent,
    PreCadastroComponent,
    EnderecoComponent,
    EnsinoMedioComponent,
    DocumentoComponent,
    DocumentosComponent,
    DocumentosComplementaresComponent,
    MensagemFinalComponent,
    MensagemFinalMatriculaOnlineComponent,
    BarraProgressoComponent,
    AppUploadComponent,
    HistoricoEscolarComponent,
    DiplomaComponent,
    AppAutoFocusDirective,
    LoaderComponent,
    AlertsComponent,
    PerguntaDocumentosComponent,
    ProcessoForaPrazoComponent,
    AppDocumentoComponent,
    SafeHtmlPipe,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    routing,
    InputMaskModule,
    FormsModule,
    HttpModule,
    SelectModule,
    TextMaskModule,
    SlimLoadingBarModule.forRoot(),
    ProgressHttpModule,
    Angulartics2Module.forRoot([Angulartics2GoogleAnalytics]),
	SweetAlert2Module.forRoot()
  ],
  providers: [
    ContatoService,
    AuthGuard,
    StepGuard,
    DatePipe,
    BarraProgressoService,
    PessoaService,
    CursosService,
    EnderecoService,
    SessionService,
	ValidadoresService,
    RedirecionamentoMatriculaService,
    ParametrosGeraisService,
    CandidatoService,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    ProcessoService,
    LoaderService,
    HeaderService,
    DocumentoService,
	AceiteTermoPrivacidadeService,
    DocumentoGlobal,
    HttpClient,
    {
      provide: Http,
      useFactory: httpServiceFactory,
      deps: [XHRBackend, RequestOptions, LoaderService],
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    AlertsService,
    MatriculaService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts